import { consoleMsg, waitForContent } from "../shared/utility";
import { initializePage } from "../shared/page-init";
import { validatePage } from "../shared/validation";
import { previous, wireIssueTextAlert } from "../shared/navigation";
import { renderNavButtons, renderQuestionOkIssueNa, renderQuestionOkIssue } from "../shared/templates.js";

const app = window.app;

export class Interior extends HTMLElement {
	async connectedCallback() {
		await waitForContent("interior");
		this.innerHTML = app.content.interior;

		// Render the navigation buttons component
		this.querySelector("#nav-slot").replaceWith(renderNavButtons("backButton4", "nextButton4"));

		//prettier-ignore
		const questions = [
			["interior-key",            "Key fob",                              "na"],
			["interior-keyless",        "Ford keyless entry pad set to 5555",   "na"],
			["interior-windows",        "Windows",                              ""],
			["interior-mirrors",        "Power mirrors",                        "na"],
			["interior-locks",          "Front and rear door locks",            ""],
			["interior-steering-wheel", "Steering wheel control/tilt",          "na"],
			["interior-usb",            "USB adaptors",                         "na"],
			["interior-wireless",       "Wireless charging",                    "na"],
			["interior-presets",        "Radio presets",                        "na"],
			["interior-clock",          "Clock and date settings",              "na"],
			["interior-dvd",            "Radio and DVD player",                 "na"],
			["interior-sirius",         "Sirius/XM radio activated",            "na"],
			["interior-horn",           "Horn",                                 ""],
			["interior-wipers",         "Windshield wipers/washer",             ""],
			["interior-panel-fit",      "Fit-and-finish of interior panels",    ""],
			["interior-sun",            "Sunroof",                              "na"],
			["interior-convertible",    "Convertible top",                      "na"],
			["interior-lights",         "Interior lights",                      ""],
			["interior-climate",        "Climate control",                      ""],
			["interior-bt",             "Bluetooth / Android Auto / Apple Carplay", "na"],
			["interior-oem",            "OEM connected services",               "na"],
			["interior-seatbelts",      "Seat belts",                           ""],
			["interior-seats",          "Seat adjustments",                     ""],
			["interior-seat-heat",      "Seat heaters/coolers",                 "na"],
			["interior-mats",           "Carpeting/floor mats",                 ""],
			["interior-trunk",          "Trunk/fuel/hood release",              ""],
			["interior-spare-tire",     "Spare tire/changing tools",            ""],
			["interior-headphones",     "Headphones",                           "na"],
			["interior-remotes",        "Remotes",                              "na"],
			["interior-tablet",         "Rear screens/tablets",                 "na"],
			["interior-wifi",           "WIFI",                                 "na"],
		];

		for (const [name, label, variant] of questions) {
			const el = variant === "na"
				? renderQuestionOkIssueNa(name, label, 4)
				: renderQuestionOkIssue(name, label, 4);
			this.querySelector(`#${name}-slot`).replaceWith(el);
		}

		this.addEventListener("ionViewWillEnter", async () => {
			const pageElement = this;
			await initializePage(4, pageElement);
		});

		this.addEventListener("ionViewDidEnter", async () => {
			wireIssueTextAlert("issueTextAlert4");
			const currentRoute = app.routes.interior;
			const nextPage = app.flowManager.getNext(currentRoute);
			const prevPage = app.flowManager.getPrevious(currentRoute);

			if (prevPage) app.state.backButton.addEventListener("click", () => previous(prevPage.route));
			if (nextPage) app.state.nextButton.addEventListener("click", () => validatePage(nextPage.route));
		});
	}
}
